// List of universities in Ghana
export const ghanaUniversities = [
  "University of Ghana",
  "Kwame Nkrumah University of Science and Technology",
  "University of Cape Coast",
  "University of Education, Winneba",
  "University for Development Studies",
  "Ghana Institute of Management and Public Administration",
  "University of Professional Studies",
  "University of Health and Allied Sciences",
  "University of Energy and Natural Resources",
  "Ghana Communication Technology University",
  "Accra Technical University",
  "Kumasi Technical University",
  "Takoradi Technical University",
  "Cape Coast Technical University",
  "Ho Technical University",
  "Koforidua Technical University",
  "Tamale Technical University",
  "Sunyani Technical University",
  "Bolgatanga Technical University",
  "Wa Technical University",
  "Ashesi University",
  "Central University",
  "Valley View University",
  "Methodist University College Ghana",
  "Catholic University College of Ghana",
  "Presbyterian University College",
  "Islamic University College",
  "Wisconsin International University College",
  "Regent University College of Science and Technology",
  "Ghana Christian University College",
  "Pentecost University",
  "All Nations University College",
  "Garden City University College",
  "Ghana Baptist University College",
  "Knutsford University College",
  "Lancaster University Ghana",
  "Academic City University College",
  "Webster University Ghana",
  "Radford University College",
  "BlueCrest University College",
  "Ghana Technology University College",
  "Zenith University College",
  "Christ Apostolic University College",
  "Data Link University College",
  "Ghana Institute of Journalism",
  "Ghana Institute of Languages",
  "Regional Maritime University"
];
